import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule, UrlModule} from '@spartacus/core';
import {KeyboardFocusModule, ListNavigationModule} from '@spartacus/storefront';
import { CustomIconsModule } from 'src/app/custom/icons/custom-icons.module';
import {CustomFacetModule} from '../custom-facet/custom-facet.module';
import {CustomFacetListComponent} from './custom-facet-list.component';
import {RouterModule} from '@angular/router';
import { CustomSortingModule } from '../../../../../shared/components/custom-sorting/custom-sorting.module';
import { CustomActiveFacetsModule } from '../active-facets/custom-active-facets.module';
import { CustomCategorySummaryModule } from '../../../../../../../custom/cms-components/content/custom-category-summary/custom-category-summary.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    CustomIconsModule,
    CustomFacetModule,
    KeyboardFocusModule,
    ListNavigationModule,
    UrlModule,
    RouterModule,
    CustomSortingModule,
    CustomActiveFacetsModule,
    CustomCategorySummaryModule,
  ],
  declarations: [CustomFacetListComponent],
  exports: [CustomFacetListComponent],
})
export class CustomFacetListModule {}
